import constants from '../../../../common/constants';

class BannerHelpers {
  static formBannersDownloadUrl(type, lang) {
    return `${constants.partners_bucket}banners/${type}/${lang}/all.zip`;
  }
}

export default BannerHelpers;



// WEBPACK FOOTER //
// ./src/app/main/banners/helpers/banner-helpers.js